import type { Step } from "../script";

export const ce3MatchBatch: Step[] = [
  {
    kind: "msg",
    id: "msg-04a",
    tokens:
      "overnight: 7 new disputes evaluated against ce 3.0. 4 matched on reason 10.4, evidence submitted. £4,200 suppressed from your vamp this week.",
    pauseAfter: 1200,
  },
  {
    kind: "panel",
    view: "transactions",
    focus: { kind: "tc40" },
    pauseAfter: 1400,
  },
  {
    kind: "msg",
    id: "msg-04b",
    tokens:
      "glowing tiles = left the vamp count. greys = still gathering evidence — acquirer has 7 days.",
    pauseAfter: 1100,
  },
];
